import { employeeHiringLink } from './employeeHiringLink';

export const es = {
  ...employeeHiringLink,
};
